export default class UserListService {
  parseList(rooms) {
    return rooms.map(user => {
      return user
    })
  }
}
